import { render } from "./search-input.vue?vue&type=template&id=b0c423ec&scoped=true"
import script from "./search-input.vue?vue&type=script&lang=js"
export * from "./search-input.vue?vue&type=script&lang=js"

import "./search-input.vue?vue&type=style&index=0&id=b0c423ec&lang=scss&scoped=true"

import exportComponent from "/var/www/birchplace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0c423ec"]])

export default __exports__